module.exports = __webpack_public_path__ + "img/blog.b11afa8e.jpg";